module.exports = __webpack_public_path__ + "img/service-icon2.a7de7e72.png";